import createVueComponent from '../createVueComponent';
export default createVueComponent('photo', 'IconPhoto', [
  ['path', { d: 'M15 8h.01', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5', key: 'svg-2' }],
  ['path', { d: 'M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3', key: 'svg-3' }],
]);
